// This is used for looking into amount instead of total length of cart items.
export const getCorrectCartCount = (cart) => {
  return cart?.reduce((acc, item) => acc + item.amount, 0) || 0;
};
